(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6927,4893,5918],{

/***/ 82817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q2": function() { return /* binding */ removeCognitoFromLocalStorage; }
/* harmony export */ });
/* unused harmony exports diff, numberWithCommas, handleLogout */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10092);
/* harmony import */ var aws_amplify__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95707);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);






function diff(x, y) {
    var keys = _to_consumable_array(Object.keys(x)).concat(_to_consumable_array(Object.keys(y))), diff = {};
    keys.map(function(key) {
        if (JSON.stringify(y[key]) !== JSON.stringify(x[key])) {
            if (x[key] !== undefined) diff[key] = x[key];
        }
    });
    return diff;
}
function numberWithCommas(x) {
    if (x === undefined) return "0";
    x = x.toString();
    var pattern = /(-?\d+)(\d{3})/;
    while(pattern.test(x))x = x.replace(pattern, "$1,$2");
    return x;
}
function removeCognitoFromLocalStorage() {
    for(var key in localStorage){
        if (key.includes("CognitoIdentityServiceProvider")) localStorage.removeItem(key);
    }
}
var handleLogout = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(e, authContext) {
        var cookies, message, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    e.preventDefault();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    aws_amplify__WEBPACK_IMPORTED_MODULE_4__/* .Auth.signOut */ .g.signOut();
                    js_cookie__WEBPACK_IMPORTED_MODULE_0___default().remove("authToken");
                    removeCognitoFromLocalStorage();
                    cookies = js_cookie__WEBPACK_IMPORTED_MODULE_0___default().get();
                    Object.keys(cookies).map(function(key) {
                        if (key.includes("CognitoIdentityServiceProvider")) js_cookie__WEBPACK_IMPORTED_MODULE_0___default().remove(key);
                    });
                    authContext.setAuth({
                        attributes: {}
                    }, false);
                    return [
                        4,
                        aws_amplify__WEBPACK_IMPORTED_MODULE_4__/* .Auth.signOut */ .g.signOut()
                    ];
                case 2:
                    _state.sent();
                    message = "Logged Out Successfully";
                    successToaster(message);
                    next_router__WEBPACK_IMPORTED_MODULE_1___default().replace("/", undefined, {
                        shallow: false
                    });
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    console.error(err.message);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleLogout(e, authContext) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 33338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5950);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);






var Container = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Container, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Container);
    function Container(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, Container);
        return _super.call(this, props);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Container, [
        {
            key: "render",
            value: function render() {
                var className = "container-fluid px-3 px-md-2 px-sm-3 px-lg-3 ";
                var childClassName = "px-1 px-md-1 px-lg-3";
                if (this.props.className) className += this.props.className;
                if (this.props.childClassName) childClassName += this.props.childClassName;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: className,
                        children: [
                            this.props.imageComp,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: childClassName,
                                children: this.props.children
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return Container;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 67292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



//import ReactPlaceholder from 'react-placeholder';
//import 'react-placeholder/lib/reactPlaceholder.css';
var Loading = function(param) {
    var size = param.size, weight = param.weight, className = param.className, color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
            [
                "d8ac03edd80a0a48",
                [
                    size ? size : "2rem",
                    size ? size : "2rem",
                    weight ? weight : "18px",
                    color ? color : "#0d6efd"
                ]
            ]
        ]) + " " + ((className ? className : "") || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                role: "status",
                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "d8ac03edd80a0a48",
                        [
                            size ? size : "2rem",
                            size ? size : "2rem",
                            weight ? weight : "18px",
                            color ? color : "#0d6efd"
                        ]
                    ]
                ]) + " " + "spinner-border text-primary"
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "d8ac03edd80a0a48",
                dynamic: [
                    size ? size : "2rem",
                    size ? size : "2rem",
                    weight ? weight : "18px",
                    color ? color : "#0d6efd"
                ],
                children: ".spinner-border.__jsx-style-dynamic-selector{width:".concat(size ? size : "2rem", "!important;height:").concat(size ? size : "2rem", "!important;font-size:").concat(weight ? weight : "18px", "!important;color:").concat(color ? color : "#0d6efd", "!important}")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Loading);


/***/ }),

/***/ 67481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _contexts_AuthContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61951);
/* harmony import */ var _config_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35055);
/* harmony import */ var react_toastify__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81782);








// import { Auth } from "aws-amplify";

react_toastify__WEBPACK_IMPORTED_MODULE_7__/* .toast.configure */ .Am.configure();
var MobileNavbar = function(param) {
    var mobileNavbar = param.mobileNavbar;
    var authContext = react__WEBPACK_IMPORTED_MODULE_2__.useContext(_contexts_AuthContext__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z);
    var currentPage = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var page = currentPage.pathname;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(), 2), cookiePopupHeight = ref[0], setCookiePopupHeight = ref[1];
    var changeClass = function(currPage) {
        if (currPage === page) return "nav-buttons-active";
        return "nav-buttons";
    };
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
        if (document.getElementById("cookie-popup-container") != null) {
            var height = document.getElementById("cookie-popup-container").clientHeight;
            setCookiePopupHeight(height);
            window.addEventListener("resize", function() {
                if (document.getElementById("cookie-popup-container") != null) {
                    var height = document.getElementById("cookie-popup-container").clientHeight;
                    setCookiePopupHeight(height);
                }
            });
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            mobileNavbar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "b3be3dd936393e20",
                        [
                            authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                        ]
                    ]
                ]) + " " + "d-block d-md-none fixed-bottom app-responsive-header py-2",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                        [
                            "b3be3dd936393e20",
                            [
                                authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                            ]
                        ]
                    ]) + " " + "row menu_items_center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                [
                                    "b3be3dd936393e20",
                                    [
                                        authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                    ]
                                ]
                            ]) + " " + "col-3 text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                        [
                                            "b3be3dd936393e20",
                                            [
                                                authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                            ]
                                        ]
                                    ]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        id: "home",
                                        className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                            [
                                                "b3be3dd936393e20",
                                                [
                                                    authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                                ]
                                            ]
                                        ]) + " " + (changeClass("/") || ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                    [
                                                        "b3be3dd936393e20",
                                                        [
                                                            authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                                        ]
                                                    ]
                                                ]) + " " + "far fa-home"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                    [
                                                        "b3be3dd936393e20",
                                                        [
                                                            authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                                        ]
                                                    ]
                                                ]) + " " + "app-responsive-menu-item",
                                                children: "Home"
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                [
                                    "b3be3dd936393e20",
                                    [
                                        authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                    ]
                                ]
                            ]) + " " + "col-3 text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: "/pricing",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                        [
                                            "b3be3dd936393e20",
                                            [
                                                authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                            ]
                                        ]
                                    ]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                            [
                                                "b3be3dd936393e20",
                                                [
                                                    authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                                ]
                                            ]
                                        ]) + " " + (changeClass("/pricing") || ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                    [
                                                        "b3be3dd936393e20",
                                                        [
                                                            authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                                        ]
                                                    ]
                                                ]) + " " + "fas fa-tag"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                    [
                                                        "b3be3dd936393e20",
                                                        [
                                                            authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                                        ]
                                                    ]
                                                ]) + " " + "app-responsive-menu-item",
                                                children: "Pricing"
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                [
                                    "b3be3dd936393e20",
                                    [
                                        authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                    ]
                                ]
                            ]) + " " + "col-3 text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: "/resources",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                        [
                                            "b3be3dd936393e20",
                                            [
                                                authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                            ]
                                        ]
                                    ]),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                            [
                                                "b3be3dd936393e20",
                                                [
                                                    authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                                ]
                                            ]
                                        ]) + " " + (changeClass("/resources") || ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                    [
                                                        "b3be3dd936393e20",
                                                        [
                                                            authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                                        ]
                                                    ]
                                                ]) + " " + "fal fa-video"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                    [
                                                        "b3be3dd936393e20",
                                                        [
                                                            authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                                        ]
                                                    ]
                                                ]) + " " + "app-responsive-menu-item",
                                                children: "Resources"
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                [
                                    "b3be3dd936393e20",
                                    [
                                        authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                    ]
                                ]
                            ]) + " " + "col-3 text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "".concat(_config_config__WEBPACK_IMPORTED_MODULE_6__/* .hostEventUrl */ .K4, "/events/create"),
                                target: "_blank",
                                rel: "noreferrer",
                                className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                    [
                                        "b3be3dd936393e20",
                                        [
                                            authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                        ]
                                    ]
                                ]),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                        [
                                            "b3be3dd936393e20",
                                            [
                                                authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                            ]
                                        ]
                                    ]) + " " + "nav-buttons",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                [
                                                    "b3be3dd936393e20",
                                                    [
                                                        authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                                    ]
                                                ]
                                            ]) + " " + "far fa-ticket-alt"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                                                [
                                                    "b3be3dd936393e20",
                                                    [
                                                        authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                                                    ]
                                                ]
                                            ]) + " " + "app-responsive-menu-item",
                                            children: "Host Events"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "b3be3dd936393e20",
                dynamic: [
                    authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px")
                ],
                children: ".app-responsive-header.__jsx-style-dynamic-selector{background:rgba(55,21,46,.8);-webkit-backdrop-filter:blur(50px);backdrop-filter:blur(50px);-webkit-border-radius:25px 25px 0px 0px;-moz-border-radius:25px 25px 0px 0px;border-radius:25px 25px 0px 0px;color:#fff;bottom:".concat(authContext.hasCookiesAccepted ? "0px" : "".concat(cookiePopupHeight, "px"), "}.nav-buttons.__jsx-style-dynamic-selector{color:#fff;text-decoration:none}.app-responsive-header.__jsx-style-dynamic-selector a.__jsx-style-dynamic-selector{text-decoration:none}.nav-buttons-active.__jsx-style-dynamic-selector{color:#fb5850}.app-responsive-header.__jsx-style-dynamic-selector i.__jsx-style-dynamic-selector{font-size:25px}.app-responsive-header.__jsx-style-dynamic-selector .app-responsive-menu-item.__jsx-style-dynamic-selector{font-size:12px}.menu_items_center.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center}")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MobileNavbar);


/***/ }),

/***/ 34893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _config_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35055);
/* harmony import */ var _helpers_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24644);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Loading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67292);
/* harmony import */ var _public_img_profile_dropdown_Circled_Menu_svg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29745);
/* harmony import */ var _public_img_profile_dropdown_Circled_Menu_svg__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_public_img_profile_dropdown_Circled_Menu_svg__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _public_img_profile_dropdown_QuizHub_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72728);
/* harmony import */ var _public_img_profile_dropdown_QuizHub_svg__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_public_img_profile_dropdown_QuizHub_svg__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _public_img_profile_dropdown_CertHub_svg__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14946);
/* harmony import */ var _public_img_profile_dropdown_CertHub_svg__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_public_img_profile_dropdown_CertHub_svg__WEBPACK_IMPORTED_MODULE_8__);


// import Tippy from "@tippyjs/react";





// import KonfHub from '../../../public/img/profile-dropdown/KonfHub.svg'


var SwitchApplications = function(param) {
    var className = param.className;
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)("menu");
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = ref1[0], setLoading = ref1[1];
    (0,_helpers_utils__WEBPACK_IMPORTED_MODULE_3__/* .clickOutside */ .xD)(wrapperRef, function() {
        setOpen(false);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loading__WEBPACK_IMPORTED_MODULE_5__["default"], {
            className: "m-auto",
            color: "#fb5850"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "switch-container position-relative ml-3 ".concat(className ? className : ""),
            children: [
                open ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "arrow-up"
                }) : "",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    ref: wrapperRef,
                    className: "switch-img-container d-inline-block",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "d-flex align-items-center justify-content-center h-100 w-100 position-relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    style: {
                                        width: "22px",
                                        height: "22px"
                                    },
                                    src: (_public_img_profile_dropdown_Circled_Menu_svg__WEBPACK_IMPORTED_MODULE_6___default()),
                                    alt: "Profile Picture"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: function() {
                                        return setOpen(!open);
                                    },
                                    className: "switch-overlay h-100 w-100 position-absolute"
                                })
                            ]
                        }),
                        open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "switch-dropDown-container p-2 position-absolute",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "switch-dropdown-options text-left",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        href: "https://quiz.konfhub.com",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "d-flex align-items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: (_public_img_profile_dropdown_QuizHub_svg__WEBPACK_IMPORTED_MODULE_7___default()),
                                                    className: "me-2",
                                                    alt: ""
                                                }),
                                                " QuizHub"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                        href: _config_config__WEBPACK_IMPORTED_MODULE_2__/* .certhubUrl */ .mF,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "d-flex align-items-center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: (_public_img_profile_dropdown_CertHub_svg__WEBPACK_IMPORTED_MODULE_8___default()),
                                                    style: {
                                                        marginRight: "10px"
                                                    },
                                                    alt: ""
                                                }),
                                                "  CertHub"
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                    children: "\n                        .switch-container {\n                            height: 40px;\n                        }\n                        .switch-img-container {\n                            height: 42px;\n                            width: 42px;\n                            border-radius: 100%;\n                            overflow: hidden;\n                            // border: 1px solid #fff;\n                            background: #fff;\n                            box-shadow:1px 1px 10px  #0002;\n                        }\n\n                        .switch-overlay {\n                            display:none;\n                            top: 0;\n                            background: #000;\n                            opacity: 0.3;\n                            border-radius: 100%;\n                        }\n\n                        .switch-img-container:hover .switch-overlay {\n                            display:block;\n                            cursor: pointer;\n                        }\n\n                        .arrow-up {\n                            width: 0; \n                            height: 0; \n                            margin-top: -50px !important;\n                            border-left: 8px solid transparent;\n                            border-right: 8px solid transparent;\n                            position: absolute;\n                            top: 87px;\n                            right: 12px;\n                            border-bottom: 16px solid white;\n                        }\n                        .switch-dropDown-container {\n                            z-index: 1030;\n                            width: 140px;\n                            background: #fff;\n                            right: 0px;\n                            border-radius: 3px;\n                            top: 48px;\n                            box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);\n                        }\n                       \n                        .switch-dropdown-options > * {\n                            display: block;\n                            width: 100%;\n                            padding: 8px 0px 8px 6px;\n                            border-radius:2px;\n                            font-size: 16px;\n                            color: #2D2D2D;\n                            font-family: Nunito;\n                            font-weight: 500;\n                            line-height: 16px;\n                            letter-spacing: 0em;\n                            text-align: left;\n                            text-decoration: none;\n                        }\n\n                        .switch-dropdown-options > *:hover {\n                            background: #80747C33;\n                            color: #2D2D2D;\n                            cursor:pointer\n                        }\n\n                        .switchEvent-pad {\n                            padding-bottom: 0.8rem !important;\n                        }\n                        "
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SwitchApplications);


/***/ }),

/***/ 28795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var eventContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
/* harmony default export */ __webpack_exports__["Z"] = (eventContext);


/***/ }),

/***/ 14946:
/***/ (function(module) {

module.exports = "/_next/static/images/CertHub-407304abde17e867a7e5df83f7f3c9fc.svg";

/***/ }),

/***/ 29745:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CjxyZWN0IHdpZHRoPSIyMiIgaGVpZ2h0PSIyMiIgZmlsbD0idXJsKCNwYXR0ZXJuMCkiLz4KPGRlZnM+CjxwYXR0ZXJuIGlkPSJwYXR0ZXJuMCIgcGF0dGVybkNvbnRlbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giIHdpZHRoPSIxIiBoZWlnaHQ9IjEiPgo8dXNlIHhsaW5rOmhyZWY9IiNpbWFnZTBfMF8zIiB0cmFuc2Zvcm09InNjYWxlKDAuMDEwNDE2NykiLz4KPC9wYXR0ZXJuPgo8aW1hZ2UgaWQ9ImltYWdlMF8wXzMiIHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgeGxpbms6aHJlZj0iZGF0YTppbWFnZS9wbmc7YmFzZTY0LGlWQk9SdzBLR2dvQUFBQU5TVWhFVWdBQUFHQUFBQUJnQ0FZQUFBRGltSGM0QUFBQUNYQklXWE1BQUFzVEFBQUxFd0VBbXB3WUFBQUIvRWxFUVZSNG5PM2NTVTdETUJTQTRhN2dIallyaGx2Z0J4ZklIUnBIT1FwVlFReVhBUzVCT1FqRHNxaklwQXRRMjZnZWFNRCtQeWtTRW9zWHhlQWs5QmVqRVFBQUFBQUFBTENsUnAyZTFGb3VhMlZtdFpMMzdqQXpxMlU2VnVZNDlZVnNNcCszdGZiZ2ZML1c1cmJXNXNOcVdhdzd2cjZuNUtZNnJQYVlsL2ppVzJVZU4xMzROY2REekNLMG1jL3paclc1OHppNTdsQnl6YnhrZStMbWJXZnpZZVpXbngweEw1SzdJZmxmL09VOVFjbUVlWkdzTXMraEMyQzFQREV2VXEza0xYZ0JsSGxsM29BTFVDdnp3cnhJYkVHU2RJdjFYd0F0MC9BdFNDNllGOG05Zm5lUGxMdDVEQjFuUGkrSSsvTkN3QTM0aW5tSnVOZHU5L3E5OWMxWHkzM01xM3FWK2J6d2sxUnkzZi9yYXVidUp6L0Z5Vldaend2bTlqMzNodXVlQU53ajZ2SXgxWDA5K1kwOTBXWStEd0FBQUFBQUFDaTIxV3hvUTh0b1ViMVBMdWRXczZVTkxhdEY5VUliS3NOK0tFOGJLa25iVjIrRVdUSnNtRVViS2tuYjE1MHVBRzFvQW14Qk11d1dSQnNxU2R0WGI3bTNtbVBhMFBKYVZHKzV0NW9WYmVncTJ0QkNXMDFMR3dvQUFBQUFBSUMvSXZkV3M2RU43ZENHRnRScXRyU2hQOUdHZmtNYktra2pBRyswb2RJVG50R0dMbUpEcVYySFo5NW9RNlV2VGFFTnRmL3MvNVI2b3cyVlliY2cybERwMllKb1F4ZXhqNFcwb1d2UWhoYldhbGEwb2F0b1F3dHROUzF0S0FBQUFBQUFBRVpwZkFJOWwzeE5XOThmUVFBQUFBQkpSVTVFcmtKZ2dnPT0iLz4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),

/***/ 88279:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0idXJsKCNwYXR0ZXJuMCkiLz4KPGRlZnM+CjxwYXR0ZXJuIGlkPSJwYXR0ZXJuMCIgcGF0dGVybkNvbnRlbnRVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giIHdpZHRoPSIxIiBoZWlnaHQ9IjEiPgo8dXNlIHhsaW5rOmhyZWY9IiNpbWFnZTBfMV80IiB0cmFuc2Zvcm09InNjYWxlKDAuMDEwNDE2NykiLz4KPC9wYXR0ZXJuPgo8aW1hZ2UgaWQ9ImltYWdlMF8xXzQiIHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgeGxpbms6aHJlZj0iZGF0YTppbWFnZS9wbmc7YmFzZTY0LGlWQk9SdzBLR2dvQUFBQU5TVWhFVWdBQUFHQUFBQUJnQ0FZQUFBRGltSGM0QUFBQUNYQklXWE1BQUFzVEFBQUxFd0VBbXB3WUFBQUNwMGxFUVZSNG5PMmRPMjVVUVJCRlh3UWhnaGdSVkJQeDJZVzdRQ0wyQ3BCRzlFV3NnZEFrV0lBTWJBWklJWGhFd0VJQWgwYUQyaU1RQ01hZTVIVlZWOThqVmZ5bTd1blBhRDdkMDBRSUlZUVFRZ2doaEJCQ3lJNDhsTDNiSmVuekl2bHpFVDFHMG5Ya0txTEh0VmNrZmZaQThpMnpnZkxvK3QyTEplVlhKZVVmMXFIQVNrYnRYZlRsL28zOUM4M0RoK1IzMWdIQVQ3MXRLZ0VwdjNiUTlOcFZpUjQxWFBQSFhYYXd0ZklKMHAyYml3dW9HNjU5cytxeWl1amg0Z0lnK1l0MW8vQmJueFlYVUVTL08yaDA3YklrZjF0Y2dIbVR5WGRSUUtJQTgxRUl6Z0Q3SU1BbHlENE1HQlQzZ0VRQjVxTVFuQUgyUVlCTGtIMFlNS2l3ZTBCSithQ0lmckFPZUV3Qm9vL3JzMWV5ZHdtaTc2MURIa3VBYk1ML2hYY0pzUVRJMytIM0lDR09BUGwvK040bGhCQlFVajdZNWJWVUNkNDI1aGdDSkgrOGYxV3Y3Q3JCMDB3SUlRQWRTd2dqQUoxS0NDVUFIVW9JSndDZFNRZ3BBQjFKQ0NzQW5VZ0lMUUFkU0FndkFNNGxMQzZnUjFZTkpWajNPbzB1WVNLMkVzNTRQR2toNGZRaHhPNFQxRE1lVFZZTlByNW15c2JmSFd4Ny90Q3NHbjV4czNnekxackErVFdYYS9jdWV3dC9GQUd6MS9CSEVEQjdEais2Z05sNytKRUZ6RDJFSDFYQTNFdjRFUVhNUFlVZlRjRGNXL2lSQk13OWhoOUdRT0ZQRTIwRjRMVHlrNTVHZnFnWmdITWtlQTAvb0FEOVI0TG44SU1LME44U3ZJY2ZXSUR5VDNyV0F0QkpoWjBCNktRb0lGR0ErU2dFWjRCOUVPQVNaQjhHRElwN1FLSUE4MUVJemdEN0lCQjFDZUxCcmJvMS9DTDU2L0o3QUk4dVhwc2VYVnh2anJDZTV2QmFvazhYRjFDdjdkZ2MxZTZnNFRUZzhmV1ZlbTJIZmNQcXF5Uy9tRnBScit1bzEzYVlONTE4VkVuNnB2azlNcWNTUkkvR1hvN3lTUjM1emNQL2s3cnUxWnNqNmp1QUVkNmlsazJQdGRmRFptcytJWVFRUWdnaGhCQkNDSmtpOEJPMU9CN3lSdkVES3dBQUFBQkpSVTVFcmtKZ2dnPT0iLz4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),

/***/ 72728:
/***/ (function(module) {

module.exports = "/_next/static/images/QuizHub-7ef1c35b635c9eabbedeac1c8bbe1464.svg";

/***/ })

}]);